import { Injector } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { STComponent, STData, STReq, STRequestOptions } from '@delon/abc/st';
import { _HttpClient } from '@delon/theme';
import { NzModalService } from 'ng-zorro-antd/modal';
import { Observable, Subject } from 'rxjs';
import { OdataService } from 'src/app/shared/services/odata.service';

export abstract class ListBaseService {
  constructor(private injector: Injector) {}
  cloneData: any | null = null;
  abstract url: string;
  abstract expandProperties: string;
  abstract batchDelete(ids: any[]): Observable<any>;

  public focusObserver = new Subject<void>();

  st!: STComponent;

  get router() {
    return this.injector.get(Router);
  }

  get route() {
    return this.injector.get(ActivatedRoute);
  }

  get http() {
    return this.injector.get(_HttpClient);
  }

  get modalService() {
    return this.injector.get(NzModalService);
  }

  searchValue = '';
  deleting = false;
  selectedRows: any[] = [];
  searchColumns = ['Code', 'Name'];
  amountColumns: string[] = [];

  req: STReq = {
    process: (options: STRequestOptions) => {
      options.params = {
        ...options.params,
        $count: 'true',
        $expand: this.expandProperties,
        $orderby: 'Code desc'
      };

      let filters: string[] = [];

      if (this.searchValue) {
        const searchStr = this.searchValue.replaceAll("'", "''");
        const odata = this.injector.get(OdataService);
        const searchFilters = odata.getSearchFilters(
          searchStr,
          this.searchColumns,
          this.amountColumns
        );

        filters = [...filters, ...searchFilters];
      }

      if (filters.length) {
        options.params['$filter'] = filters.map(x => `(${x})`).join(' or ');
      }

      return options;
    }
  };
  res = {
    process: (data: STData[], _: any) => {
      if (this.selectedRows.length) this.selectedRows = [];
      return data;
    }
  };

  addRow(row: any) {
    if (this.st) {
      // If st table is using a string data source, reload the data source
      if (typeof this.st.data === 'string') {
        this.st.reload();
      } else {
        // If st table is using an array data source, add the new row to the data source
        this.st.addRow(row, { index: 0 });
      }
    }
  }

  updateRow(row: any) {
    if (this.st) {
      // If st table is using a string data source, reload the data source
      if (typeof this.st.data === 'string') {
        this.st.reload();
      } else {
        // If st table is using an array data source, add the update row to the data source
        const stRow = this.st._data.find(x => x['id'] === row.id);
        if (stRow) {
          Object.assign(stRow, row);
        }
        this.st.reload();
      }
    }
  }

  removeRow(row: any) {
    if (this.st) {
      const stRow = this.st._data.find(x => x['id'] === row.id);
      if (stRow) this.st.removeRow(stRow);
    }
  }

  notifySelection(data: any[]) {
    const res = data.filter(w => !w.disabled && w.checked === true);
    this.selectedRows = res;
  }

  gotoDetail(id: any) {
    const listUrl = window.location.href;
    let detailRoute = listUrl.substring(
      listUrl.indexOf('#') + 1,
      listUrl.lastIndexOf('/')
    );
    detailRoute += `/detail/${id}`;
    this.router.navigateByUrl(detailRoute);
  }

  onAction(action: string, data: any): Promise<boolean> {
    return new Promise(resolve => {
      resolve(true);
    });
  }

  reset() {
    this.selectedRows = [];
    this.deleting = false;
    this.searchValue = '';
  }

  getSearchFilterString(searchValue: string) {
    const odata = this.injector.get(OdataService);
    return odata.getSearchFilterString(
      searchValue,
      this.searchColumns,
      this.amountColumns
    );
  }

  focus() {
    this.focusObserver.next();
  }
}
